import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = ['client-id'] as const

export const ftscDocumentTypes = [
  'signed-bol',
  'proof-of-delivery',
  'invoice',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export type ftscCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const ftsc: CarrierDef<ftscCredType> = {
  name: 'Fort Transportation',
  scac: 'ftsc',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['client-id', 'ref1']],
  engineLayers: ['rating', 'pickup', 'tracking', 'profinder', 'documents'],
  documentTypes: ftscDocumentTypes,
  credentialConfig: {
    'client-id': { customerIdentifier: true },
  },
}
